<template>
  <c_HuiFuMain
    :dh="state.dh"
    type="T_JSAPI"
    :key="state.dh"
    @onSubmit="onSubmit"
  ></c_HuiFuMain>
</template>

<script>
import { onMounted, reactive, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { huifu_getopenid, huifu_create, huifu_createH5 } from "@/http/api";
import { ElMessage } from "element-plus";
export default {
  setup() {
    const route = useRoute();
    const state = reactive({});
    let redirectTimer = null;

    onMounted(() => {
      state.dh = route.query.dh;

      const url = window.location.href;
      const beginIndex = url.indexOf("code");
      const endIndex = url.indexOf("&");
      if (beginIndex < 0 || endIndex < 0) {
        //如果url中不包含code参数，由于微信的回调地址不支持hash模式的路由，所以地址中不能带有#号，所以整体地址为：http://ra.gujinghotels.com:82/?code=8Maea6TwUpVhQ1qqE893kQzxyJD9qVwPVPFi560VXsc&state=STATE#/?storeid=1
        state.statusCode = 400;
        return false;
      }

      state.weChatCode = window.location.href.slice(beginIndex + 5, endIndex);

      huifu_getopenid(state.weChatCode).then((res) => {
        if (res.status == 200) {
          state.openid = res.data;
        }
      });
    });

    onUnmounted(() => {
      // 组件卸载时清除定时器
      if (redirectTimer) {
        clearTimeout(redirectTimer);
      }
    });

    const onSubmit = (item) => {
      item.OpenId = state.openid;
      if (route.query.ph && route.query._t) {
        huifu_createH5("Wx", item, route.query.ph, route.query._t)
          .then((res) => {
            if (res.status === 200) {
              if (typeof res.data === "object") wechatPay(res.data);
            }
          })
          .finally(() => {
            state.loading = false;
          });
      } else {
        huifu_create("T_JSAPI", item).then((res) => {
          if (res.status == 200) {
            if (typeof res.data === "object") wechatPay(res.data);
            else ElMessage.warning("请使用支付宝扫码支付！");
          }
        });
      }
    };

    const wechatPay = (result) => {
      //封装请求微信支付接口数据
      var request_data = {
        appId: result.appId,
        timeStamp: result.timeStamp,
        nonceStr: result.nonceStr,
        package: result.package,
        signType: "RSA",
        paySign: result.paySign,
      };

      window.WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        request_data,
        (res) => {
          if (res.err_msg.indexOf("ok") > -1) {
            if (!route.query.ph && !route.query._t)
              ElMessage({ type: "success", message: "支付成功" });
            else {
              // 增强跳转方案，防止点金计划页面拦截
              const targetUrl =
                "http://www.lx-tour.com:27182/#/h5/ticket/" +
                state.dh +
                "?ph=" +
                route.query.ph +
                "&_t=" +
                route.query._t;

              // 方案1：立即使用location.replace强制跳转
              try {
                window.location.replace(targetUrl);
              } catch (e) {
                console.error("首次跳转失败:", e);
              }

              // 方案2：多重延时跳转，增加多个时间点尝试
              redirectTimer = setTimeout(() => {
                try {
                  window.location.href = targetUrl;
                } catch (e) {
                  console.error("500ms跳转失败:", e);
                }
              }, 500);

              // 方案3：1秒后再次尝试
              setTimeout(() => {
                try {
                  window.location.replace(targetUrl);
                } catch (e) {
                  console.error("1000ms跳转失败:", e);
                }
              }, 1000);

              // 方案4：2秒后最后尝试
              setTimeout(() => {
                try {
                  window.location.href = targetUrl;
                } catch (e) {
                  console.error("2000ms跳转失败:", e);
                }
              }, 2000);

              // 方案5：如果支持WeixinJSBridge，尝试使用它来控制
              try {
                if (
                  window.WeixinJSBridge &&
                  typeof window.WeixinJSBridge.navigateTo === "function"
                ) {
                  window.WeixinJSBridge.navigateTo({
                    url: targetUrl.substring(1),
                  });
                }
              } catch (e) {
                console.error("WeixinJSBridge跳转失败:", e);
              }
            }
          }
        }
      );
    };
    return { state, onSubmit };
  },
};
</script>
<style scoped></style>
